// contexts/NotificationContext.jsx

import { createContext, useContext, useState } from "react";

import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notificationLoading, setNotificationLoading] = useState(false);

  const [notificationError, setNotificationError] = useState(null);

  const [notificationData, setNotificationData] = useState(null);

  /* =========================================
     PROCESS SIGNAL NOTIFICATIONS
  ========================================= */

  const processSignalNotifications = async () => {
    try {
      setNotificationLoading(true);

      setNotificationError(null);

      const response = await axios.post(
        `${BASE_URL}/api/processSignalNotifications`,
      );

      console.log("✅ Notification response:", response.data);

      setNotificationData(response.data);

      return response.data;
    } catch (err) {
      console.error("❌ Notification processing failed:", err.message);

      setNotificationError(
        err.response?.data?.message || "Failed to process notifications",
      );

      return null;
    } finally {
      setNotificationLoading(false);
    }
  };

  return (
    <NotificationContext.Provider
      value={{
        processSignalNotifications,

        notificationLoading,
        notificationError,
        notificationData,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
